import { injectable } from "@codemation/core";

@injectable()
export class SecureRequestDetector {
  isSecureRequest(request: Request): boolean {
    const forwardedProto = request.headers.get("x-forwarded-proto")?.split(",")[0]?.trim().toLowerCase();
    if (forwardedProto === "https") {
      return true;
    }
    return new URL(request.url).protocol === "https:";
  }
}
